import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {propTypes} from 'react-props-decorators';
import classNames from 'classnames';

import _ from 'lodash';
import './index.less';
import moment from "moment";
import formats from "dictionaries/formats";
import ReactTooltip from "react-tooltip";

export default class VehicleMarkerPopup extends Component {

    render() {
        const device = this.props.device;
        const vehicle = this.props.vehicle;
        const vehicleCarrier = this.props.vehicleCarrier;

        return (
            <div className="b-modal b-modal-map map-tooltip-modal tooltip-ts">
                <ReactTooltip/>
                <div className="b-modal__header">
                    <a href="#" className="b-modal__close" onClick={::this.onClose}/>
                    <div
                        className="b-modal__name">
                        {vehicle.state_number}
                        &nbsp;
                        {(vehicle.vehicle_type) ? vehicle.vehicle_type : this.props.vehicleMark}
                    </div>
                    <div className="b-modal__datetime">Данные получены: {moment.unix(device.time).format(formats.DATETIME)}</div>
                    <div className="b-modal__datetime b-modal__vehicle-type">{this.props.vehicleModel || '-'}</div>
                </div>
                <div className="b-modal__body">
                    <div className="b-block">
                        <div className="b-block__desc">Направление</div>
                        <div className="b-block__value">{this.getCourseText()} <span className="b-block__direction"
                                                                                     style={{transform: `rotate(${device.course}deg)`}}/>
                        </div>
                    </div>
                    {vehicle.route_number ? (
                        <div className="b-block">
                            <div className="b-block__desc">Маршрут</div>
                            <div className="b-block__value">№ {vehicle.route_number}, {vehicle.route_name}</div>
                        </div>
                    ) : null}
                    {vehicleCarrier ? (
                        <div className="b-block">
                            <div className="b-block__desc">Перевозчик</div>
                            <div className="b-block__value">{vehicleCarrier}</div>
                        </div>
                    ) : null}
                </div>
                <div className="b-modal__footer">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-xs-12 ">
                                <ul className="b-modal__footer-list b-modal__footer-list_start ">
                                    {vehicle.is_cashless_payment ? (
                                        <li className="b-modal__footer-item ">
                                            <span data-tip="Безналичная оплата"
                                                  className="b-modal__footer-icon b-modal__footer-icon-credit-card"/>
                                        </li>
                                    ) : null}
                                    {vehicle.is_low_floor_level ? (
                                        <li className="b-modal__footer-item ">
                                            <span data-tip="Низкий уровень пола"
                                                  className="b-modal__footer-icon b-modal__footer-icon-download"/>
                                        </li>
                                    ) : null}
                                    {vehicle.is_audio_video_fixation ? (
                                        <li className="b-modal__footer-item ">
                                            <span data-tip="Аудио/Видео фиксация"
                                                  className="b-modal__footer-icon b-modal__footer-icon-camera "/>
                                        </li>
                                    ) : null}
                                    {vehicle.is_passenger_monitoring_system ? (
                                        <li className="b-modal__footer-item ">
                                            <span data-tip="система мониторинга пассажиропотока"
                                                  className="b-modal__footer-icon b-modal__footer-icon-camera-eye "/>
                                        </li>
                                    ) : null}
                                    {vehicle.is_for_disabled ? (
                                        <li className="b-modal__footer-item ">
                                            <span
                                                data-tip="Оснащено для перевозки инвалидов"
                                                className="b-modal__footer-icon b-modal__footer-icon-people-disabled "/>
                                        </li>
                                    ) : null}
                                    {vehicle.is_air_conditioning_installation ? (
                                        <li className="b-modal__footer-item ">
                                            <span data-tip="Климатическая установка"
                                                  className="b-modal__footer-icon b-modal__footer-icon-climate "/>
                                        </li>
                                    ) : null}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    getCourseText() {
        const course = this.props.device.course;

        if ((course >= 360 - 22.5) || (course <= 22.5)) {
            return 'Север';
        }
        if ((course >= 22.5) && (course <= 67.5)) {
            return 'Северо-Восток';
        }
        if ((course >= 67.5) && (course <= 112.5)) {
            return 'Восток';
        }
        if ((course >= 112.5) && (course <= 157.5)) {
            return 'Юго-Восток';
        }
        if ((course >= 157.5) && (course <= 202.5)) {
            return 'Юг';
        }
        if ((course >= 202.5) && (course <= 247.5)) {
            return 'Юго-Запад';
        }
        if ((course >= 247.5) && (course <= 292.5)) {
            return 'Запад';
        }
        if ((course >= 292.5) && (course <= 337.5)) {
            return 'Северо-Запад';
        }
    }

    onClose(e) {
        e && e.preventDefault();

        this.props.onClose();
    }
}



// WEBPACK FOOTER //
// ./src/components/modules/map/elements/popup/index.js